import { n as e, t } from "./apiUrls-BSq_pH-y.js";
import * as n from "zod";
//#region src/generated/core/bodySerializer.gen.ts
var r = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var i = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				let n = Math.min(c * 2 ** (p - 1), s ?? 3e4);
				await f(n);
			}
		}
	}() };
}, a = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, o = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, s = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, c = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(o(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let s = a(r), c = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : l({
		allowReserved: e,
		name: n,
		value: t
	})).join(s);
	return r === "label" || r === "matrix" ? s + c : c;
}, l = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, u = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = s(r), c = Object.entries(i).map(([t, i]) => l({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + c : c;
}, d = /\{[^{}]+\}/g, f = ({ path: e, url: t }) => {
	let n = t, r = t.match(d);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, c({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, u({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${l({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, p = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = f({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function m(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var h = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, g = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = c({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = u({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = l({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, ee = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, te = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, ne = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (te(t, n.name)) continue;
		let e = await h(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default:
				t.headers.set(r, e);
				break;
		}
	}
}, _ = (e) => p({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : g(e.querySerializer),
	url: e.url
}), v = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = y(e.headers, t.headers), n;
}, re = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, y = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? re(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, b = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, ie = () => ({
	error: new b(),
	request: new b(),
	response: new b()
}), ae = g({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), oe = { "Content-Type": "application/json" }, x = (e = {}) => ({
	...r,
	headers: oe,
	parseAs: "auto",
	querySerializer: ae,
	...e
}), S = ((e = {}) => {
	let t = v(x(), e), n = () => ({ ...t }), r = (e) => (t = v(t, e), n()), a = ie(), o = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: y(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await ne({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: _(n)
		};
	}, s = async (e) => {
		let { opts: t, url: n } = await o(e), r = {
			redirect: "follow",
			...t,
			body: m(t)
		}, i = new Request(n, r);
		for (let e of a.request.fns) e && (i = await e(i, t));
		let s = t.fetch, c;
		try {
			c = await s(i);
		} catch (e) {
			let n = e;
			for (let r of a.error.fns) r && (n = await r(e, void 0, i, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: i,
				response: void 0
			};
		}
		for (let e of a.response.fns) e && (c = await e(c, i, t));
		let l = {
			request: i,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? ee(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default:
						n = {};
						break;
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of a.error.fns) e && (p = await e(f, c, i, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, c = (e) => (t) => s({
		...t,
		method: e
	}), l = (e) => async (t) => {
		let { opts: n, url: r } = await o(t);
		return i({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of a.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: m(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => _({
			...t,
			...e
		}),
		connect: c("CONNECT"),
		delete: c("DELETE"),
		get: c("GET"),
		getConfig: n,
		head: c("HEAD"),
		interceptors: a,
		options: c("OPTIONS"),
		patch: c("PATCH"),
		post: c("POST"),
		put: c("PUT"),
		request: s,
		setConfig: r,
		sse: {
			connect: l("CONNECT"),
			delete: l("DELETE"),
			get: l("GET"),
			head: l("HEAD"),
			options: l("OPTIONS"),
			patch: l("PATCH"),
			post: l("POST"),
			put: l("PUT"),
			trace: l("TRACE")
		},
		trace: c("TRACE")
	};
})(x({
	baseUrl: "https://lightspeed.ecommerce.api.myparcel.nl",
	throwOnError: !0
})), C = n.enum(["MINUTES"]), w = n.object({
	id: n.uuid().register(n.globalRegistry, { description: "The sales channel ID." }),
	createdAt: n.iso.datetime().register(n.globalRegistry, { description: "Sales channel created at." }),
	extraction: n.object({ lastCycle: n.object({
		extractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(n.globalRegistry, { description: "Last order extraction cycle." }).optional() }).register(n.globalRegistry, { description: "Order extraction configuration." }).optional(),
	fulfilmentPlatforms: n.tuple([n.enum(["VASCO"]).register(n.globalRegistry, { description: "The fulfilment platform." })]).register(n.globalRegistry, { description: "The fulfilment platforms." }).optional(),
	name: n.string().min(3).max(50).register(n.globalRegistry, { description: "Custom sales channel name." }),
	shopId: n.string().min(1).max(50).register(n.globalRegistry, { description: "Owning shop ID for the sales channel." }),
	url: n.url().max(250).register(n.globalRegistry, { description: "The URL of the Lightspeed store." }),
	delegationError: n.object({
		reason: n.string().register(n.globalRegistry, { description: "Error reason." }),
		details: n.string().register(n.globalRegistry, { description: "More detailed information about the error." }).optional()
	}).register(n.globalRegistry, { description: "Delegation error." }),
	status: n.enum(["DELEGATION_REQUIRED"]).register(n.globalRegistry, { description: "Connection status which indicates that a connection authorization is required." })
}), T = n.object({
	id: n.uuid().register(n.globalRegistry, { description: "The sales channel ID." }),
	createdAt: n.iso.datetime().register(n.globalRegistry, { description: "Sales channel created at." }),
	extraction: n.object({
		lastCycle: n.object({
			extractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
			successfullyExtractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction at." }).optional(),
			transformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
			successfullyTransformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
		}).register(n.globalRegistry, { description: "Last order extraction cycle." }).optional(),
		schedule: n.object({
			transformAndLoad: n.boolean().register(n.globalRegistry, { description: "Whether orders should be automatically imported." }),
			unit: C.and(n.unknown().register(n.globalRegistry, { description: "Time unit which is used for scheduled order loading." })),
			value: n.int().gt(0).register(n.globalRegistry, { description: "Amount of time units between each scheduled order loading attempt." })
		}).register(n.globalRegistry, { description: "Schedule which is used for order loading." })
	}).register(n.globalRegistry, { description: "Order extraction configuration." }),
	fulfilmentPlatforms: n.tuple([n.enum(["VASCO"]).register(n.globalRegistry, { description: "The fulfilment platform." })]).register(n.globalRegistry, { description: "The fulfilment platforms." }).optional(),
	name: n.string().min(3).max(50).register(n.globalRegistry, { description: "Custom sales channel name." }),
	shopId: n.string().min(1).max(50).register(n.globalRegistry, { description: "Owning shop ID for the sales channel." }),
	url: n.url().max(250).register(n.globalRegistry, { description: "The URL of the Lightspeed store." }),
	apiCredentialsLastTokens: n.object({
		key: n.string().length(4).register(n.globalRegistry, { description: "API key." }),
		secret: n.string().length(4).register(n.globalRegistry, { description: "API secret." })
	}).register(n.globalRegistry, { description: "Last N tokens when API credentials are used." }),
	status: n.enum(["DELEGATION_ISSUED"]).register(n.globalRegistry, { description: "Status for the connection with the sales channel for which orders will be extracted from." })
}), E = n.object({
	id: n.uuid().register(n.globalRegistry, { description: "The sales channel ID." }),
	createdAt: n.iso.datetime().register(n.globalRegistry, { description: "Sales channel created at." }),
	extraction: n.object({ lastCycle: n.object({
		extractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(n.globalRegistry, { description: "Last order extraction cycle." }).optional() }).register(n.globalRegistry, { description: "Order extraction configuration." }).optional(),
	fulfilmentPlatforms: n.tuple([n.enum(["VASCO"]).register(n.globalRegistry, { description: "The fulfilment platform." })]).register(n.globalRegistry, { description: "The fulfilment platforms." }).optional(),
	name: n.string().min(3).max(50).register(n.globalRegistry, { description: "Custom sales channel name." }),
	shopId: n.string().min(1).max(50).register(n.globalRegistry, { description: "Owning shop ID for the sales channel." }),
	url: n.url().max(250).register(n.globalRegistry, { description: "The URL of the Lightspeed store." }),
	authorizeUrl: n.url().register(n.globalRegistry, { description: "Authorization URL for the sales channel." }),
	status: n.enum(["DELEGATION_REQUESTED"]).register(n.globalRegistry, { description: "Connection status which indicates that a connection authorization has been requested but not yet confirmed." })
}), D = n.union([
	n.object({ status: n.literal("DELEGATION_REQUIRED") }).and(w),
	n.object({ status: n.literal("DELEGATION_ISSUED") }).and(T),
	n.object({ status: n.literal("DELEGATION_REQUESTED") }).and(E)
]), O = n.object({
	fulfilmentPlatforms: n.tuple([n.enum(["VASCO"]).register(n.globalRegistry, { description: "The fulfilment platform." })]).register(n.globalRegistry, { description: "Set of fulfilment platforms." }).optional(),
	name: n.string().min(3).max(50).register(n.globalRegistry, { description: "The name of the sales channel." }),
	shopId: n.string().min(1).max(50).register(n.globalRegistry, { description: "The shop ID." }),
	url: n.url().max(250)
}), se = n.array(n.object({ id: n.uuid().register(n.globalRegistry, { description: "The sales channel to extract orders for" }) })).min(1).max(25), ce = n.object({ salesChannelId: n.uuid().register(n.globalRegistry, { description: "The sales channel ID." }) }), k = n.object({ salesChannelId: n.uuid().register(n.globalRegistry, { description: "The sales channel ID." }) }), A = n.object({ salesChannelIds: n.array(n.uuid()).min(1).max(150).register(n.globalRegistry, { description: "The sales channel id to import products for" }) }), j = n.object({
	salesChannelId: n.uuid().register(n.globalRegistry, { description: "The sales channel ID." }),
	fulfilmentPlatforms: n.tuple([n.enum(["VASCO"]).register(n.globalRegistry, { description: "The fulfilment platform." })]).register(n.globalRegistry, { description: "The fulfilment platforms." }).optional()
}), M = n.object({ salesChannelId: n.uuid().register(n.globalRegistry, { description: "The ID of the sales channel." }) }), N = n.object({
	salesChannelId: n.uuid().register(n.globalRegistry, { description: "The ID of the sales channel." }),
	name: n.string().min(3).max(50).register(n.globalRegistry, { description: "The name of the sales channel." })
}), P = n.object({ salesChannelId: n.uuid().register(n.globalRegistry, { description: "The sales channel ID." }) }), F = n.object({
	type: n.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]).register(n.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: n.union([
		n.literal(400),
		n.literal(401),
		n.literal(404),
		n.literal(415),
		n.literal(500)
	]).register(n.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: n.string().min(1).max(100).register(n.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: n.string().min(1).max(5e3).register(n.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: n.url().register(n.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: n.unknown().register(n.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), le = F.and(n.object({
	type: n.enum(["urn:problem:invalid-request-syntax"]).register(n.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: n.literal(400).register(n.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: n.array(n.object({
		detail: n.string().min(1).max(5e3),
		pointer: n.string().min(1).max(200).register(n.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(n.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), ue = F.and(n.object({
	type: n.enum(["urn:problem:not-found"]).register(n.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: n.literal(404).register(n.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
})), I = n.object({
	body: O,
	path: n.never().optional(),
	query: n.never().optional()
}), de = n.union([n.object({ status: n.literal("DELEGATION_REQUESTED") }).and(E), n.object({ status: n.literal("DELEGATION_REQUIRED") }).and(w)]), L = n.object({
	body: se,
	path: n.never().optional(),
	query: n.never().optional()
}), R = n.object({
	body: ce,
	path: n.never().optional(),
	query: n.never().optional()
}), fe = T.and(n.object({ extraction: n.object({
	lastCycle: n.object({
		extractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(n.globalRegistry, { description: "Last order extraction cycle." }).optional(),
	schedule: n.object({
		transformAndLoad: n.literal(!1),
		unit: C.and(n.unknown().register(n.globalRegistry, { description: "Time unit which is used for scheduled order loading." })),
		value: n.int().gt(0).register(n.globalRegistry, { description: "Amount of time units between each scheduled order loading attempt." })
	}).register(n.globalRegistry, { description: "Schedule which is used for order loading." })
}).register(n.globalRegistry, { description: "Order extraction configuration." }).optional() })), z = n.object({
	body: k,
	path: n.never().optional(),
	query: n.never().optional()
}), pe = T.and(n.object({ extraction: n.object({
	lastCycle: n.object({
		extractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(n.globalRegistry, { description: "Last order extraction cycle." }).optional(),
	schedule: n.object({
		transformAndLoad: n.literal(!0),
		unit: C.and(n.unknown().register(n.globalRegistry, { description: "Time unit which is used for scheduled order loading." })),
		value: n.int().gt(0).register(n.globalRegistry, { description: "Amount of time units between each scheduled order loading attempt." })
	}).register(n.globalRegistry, { description: "Schedule which is used for order loading." })
}).register(n.globalRegistry, { description: "Order extraction configuration." }).optional() })), B = n.object({
	body: A,
	path: n.never().optional(),
	query: n.never().optional()
}), V = n.object({
	body: j,
	path: n.never().optional(),
	query: n.never().optional()
}), me = D, H = n.object({
	body: M,
	path: n.never().optional(),
	query: n.never().optional()
}), he = n.void().register(n.globalRegistry, { description: "Successful removal." }), U = n.object({
	body: N,
	path: n.never().optional(),
	query: n.never().optional()
}), ge = D, W = n.object({
	body: P,
	path: n.never().optional(),
	query: n.never().optional()
}), _e = n.union([n.object({ status: n.literal("DELEGATION_REQUESTED") }).and(E), n.object({ status: n.literal("DELEGATION_REQUIRED") }).and(w)]), ve = n.object({
	body: n.never().optional(),
	path: n.never().optional(),
	query: n.object({ filter: n.object({ shopId: n.array(n.string().min(1).max(50)).min(1).max(100).optional() }).optional() }).optional()
}), ye = n.object({ results: n.array(D).min(0).max(25) }).register(n.globalRegistry, { description: "Found sales channels." }), G = n.object({
	body: n.never().optional(),
	path: n.object({ salesChannelId: n.uuid().register(n.globalRegistry, { description: "The ID of the sales channel." }) }),
	query: n.never().optional()
}), be = D, K = n.union([n.enum(["MINUTES"]), n.string()]), q = n.object({
	id: n.uuid().register(n.globalRegistry, { description: "The sales channel ID." }),
	createdAt: n.iso.datetime().register(n.globalRegistry, { description: "Sales channel created at." }),
	extraction: n.object({ lastCycle: n.object({
		extractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(n.globalRegistry, { description: "Last order extraction cycle." }).optional() }).register(n.globalRegistry, { description: "Order extraction configuration." }).optional(),
	fulfilmentPlatforms: n.tuple([n.union([n.enum(["VASCO"]), n.string()]).register(n.globalRegistry, { description: "The fulfilment platform." })]).register(n.globalRegistry, { description: "The fulfilment platforms." }).optional(),
	name: n.string().register(n.globalRegistry, { description: "Custom sales channel name." }),
	shopId: n.string().register(n.globalRegistry, { description: "Owning shop ID for the sales channel." }),
	url: n.url().max(250).register(n.globalRegistry, { description: "The URL of the Lightspeed store." }),
	delegationError: n.object({
		reason: n.string().register(n.globalRegistry, { description: "Error reason." }),
		details: n.string().register(n.globalRegistry, { description: "More detailed information about the error." }).optional()
	}).register(n.globalRegistry, { description: "Delegation error." }),
	status: n.union([n.enum(["DELEGATION_REQUIRED"]), n.string()]).register(n.globalRegistry, { description: "Connection status which indicates that a connection authorization is required." })
}), J = n.object({
	id: n.uuid().register(n.globalRegistry, { description: "The sales channel ID." }),
	createdAt: n.iso.datetime().register(n.globalRegistry, { description: "Sales channel created at." }),
	extraction: n.object({
		lastCycle: n.object({
			extractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
			successfullyExtractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction at." }).optional(),
			transformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
			successfullyTransformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
		}).register(n.globalRegistry, { description: "Last order extraction cycle." }).optional(),
		schedule: n.object({
			transformAndLoad: n.boolean().register(n.globalRegistry, { description: "Whether orders should be automatically imported." }),
			unit: K.and(n.unknown().register(n.globalRegistry, { description: "Time unit which is used for scheduled order loading." })),
			value: n.int().gt(0).register(n.globalRegistry, { description: "Amount of time units between each scheduled order loading attempt." })
		}).register(n.globalRegistry, { description: "Schedule which is used for order loading." })
	}).register(n.globalRegistry, { description: "Order extraction configuration." }),
	fulfilmentPlatforms: n.tuple([n.union([n.enum(["VASCO"]), n.string()]).register(n.globalRegistry, { description: "The fulfilment platform." })]).register(n.globalRegistry, { description: "The fulfilment platforms." }).optional(),
	name: n.string().register(n.globalRegistry, { description: "Custom sales channel name." }),
	shopId: n.string().register(n.globalRegistry, { description: "Owning shop ID for the sales channel." }),
	url: n.url().max(250).register(n.globalRegistry, { description: "The URL of the Lightspeed store." }),
	apiCredentialsLastTokens: n.object({
		key: n.string().register(n.globalRegistry, { description: "API key." }),
		secret: n.string().register(n.globalRegistry, { description: "API secret." })
	}).register(n.globalRegistry, { description: "Last N tokens when API credentials are used." }),
	status: n.union([n.enum(["DELEGATION_ISSUED"]), n.string()]).register(n.globalRegistry, { description: "Status for the connection with the sales channel for which orders will be extracted from." })
}), Y = n.object({
	id: n.uuid().register(n.globalRegistry, { description: "The sales channel ID." }),
	createdAt: n.iso.datetime().register(n.globalRegistry, { description: "Sales channel created at." }),
	extraction: n.object({ lastCycle: n.object({
		extractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(n.globalRegistry, { description: "Last order extraction cycle." }).optional() }).register(n.globalRegistry, { description: "Order extraction configuration." }).optional(),
	fulfilmentPlatforms: n.tuple([n.union([n.enum(["VASCO"]), n.string()]).register(n.globalRegistry, { description: "The fulfilment platform." })]).register(n.globalRegistry, { description: "The fulfilment platforms." }).optional(),
	name: n.string().register(n.globalRegistry, { description: "Custom sales channel name." }),
	shopId: n.string().register(n.globalRegistry, { description: "Owning shop ID for the sales channel." }),
	url: n.url().max(250).register(n.globalRegistry, { description: "The URL of the Lightspeed store." }),
	authorizeUrl: n.url().register(n.globalRegistry, { description: "Authorization URL for the sales channel." }),
	status: n.union([n.enum(["DELEGATION_REQUESTED"]), n.string()]).register(n.globalRegistry, { description: "Connection status which indicates that a connection authorization has been requested but not yet confirmed." })
}), X = n.union([
	n.object({ status: n.literal("DELEGATION_REQUIRED") }).and(q),
	n.object({ status: n.literal("DELEGATION_ISSUED") }).and(J),
	n.object({ status: n.literal("DELEGATION_REQUESTED") }).and(Y)
]), xe = n.object({
	fulfilmentPlatforms: n.tuple([n.union([n.enum(["VASCO"]), n.string()]).register(n.globalRegistry, { description: "The fulfilment platform." })]).register(n.globalRegistry, { description: "Set of fulfilment platforms." }).optional(),
	name: n.string().register(n.globalRegistry, { description: "The name of the sales channel." }),
	shopId: n.string().register(n.globalRegistry, { description: "The shop ID." }),
	url: n.url().max(250)
}), Se = n.array(n.object({ id: n.uuid().register(n.globalRegistry, { description: "The sales channel to extract orders for" }) })), Ce = n.object({ salesChannelId: n.uuid().register(n.globalRegistry, { description: "The sales channel ID." }) }), we = n.object({ salesChannelId: n.uuid().register(n.globalRegistry, { description: "The sales channel ID." }) }), Te = n.object({ salesChannelIds: n.array(n.uuid()).register(n.globalRegistry, { description: "The sales channel id to import products for" }) }), Ee = n.object({
	salesChannelId: n.uuid().register(n.globalRegistry, { description: "The sales channel ID." }),
	fulfilmentPlatforms: n.tuple([n.union([n.enum(["VASCO"]), n.string()]).register(n.globalRegistry, { description: "The fulfilment platform." })]).register(n.globalRegistry, { description: "The fulfilment platforms." }).optional()
}), De = n.object({ salesChannelId: n.uuid().register(n.globalRegistry, { description: "The ID of the sales channel." }) }), Oe = n.object({
	salesChannelId: n.uuid().register(n.globalRegistry, { description: "The ID of the sales channel." }),
	name: n.string().register(n.globalRegistry, { description: "The name of the sales channel." })
}), ke = n.object({ salesChannelId: n.uuid().register(n.globalRegistry, { description: "The sales channel ID." }) }), Z = n.object({
	type: n.union([n.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]), n.string()]).register(n.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: n.union([
		n.literal(400),
		n.literal(401),
		n.literal(404),
		n.literal(415),
		n.literal(500)
	]).register(n.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: n.string().register(n.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: n.string().register(n.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: n.url().register(n.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: n.unknown().register(n.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
});
Z.and(n.object({
	type: n.union([n.enum(["urn:problem:invalid-request-syntax"]), n.string()]).register(n.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: n.literal(400).register(n.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: n.array(n.object({
		detail: n.string(),
		pointer: n.string().register(n.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(n.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), Z.and(n.object({
	type: n.union([n.enum(["urn:problem:not-found"]), n.string()]).register(n.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: n.literal(404).register(n.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
})), n.object({
	body: xe,
	path: n.never().optional(),
	query: n.never().optional()
});
var Ae = n.union([n.object({ status: n.literal("DELEGATION_REQUESTED") }).and(Y), n.object({ status: n.literal("DELEGATION_REQUIRED") }).and(q)]);
n.object({
	body: Se,
	path: n.never().optional(),
	query: n.never().optional()
}), n.object({
	body: Ce,
	path: n.never().optional(),
	query: n.never().optional()
});
var je = J.and(n.object({ extraction: n.object({
	lastCycle: n.object({
		extractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(n.globalRegistry, { description: "Last order extraction cycle." }).optional(),
	schedule: n.object({
		transformAndLoad: n.literal(!1),
		unit: K.and(n.unknown().register(n.globalRegistry, { description: "Time unit which is used for scheduled order loading." })),
		value: n.int().gt(0).register(n.globalRegistry, { description: "Amount of time units between each scheduled order loading attempt." })
	}).register(n.globalRegistry, { description: "Schedule which is used for order loading." })
}).register(n.globalRegistry, { description: "Order extraction configuration." }).optional() }));
n.object({
	body: we,
	path: n.never().optional(),
	query: n.never().optional()
});
var Me = J.and(n.object({ extraction: n.object({
	lastCycle: n.object({
		extractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction attempt at." }).optional(),
		successfullyExtractedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction at." }).optional(),
		transformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last order extraction and loading attempt at." }).optional(),
		successfullyTransformedAndLoadedAt: n.iso.datetime().register(n.globalRegistry, { description: "Last successful order extraction and loading at." }).optional()
	}).register(n.globalRegistry, { description: "Last order extraction cycle." }).optional(),
	schedule: n.object({
		transformAndLoad: n.literal(!0),
		unit: K.and(n.unknown().register(n.globalRegistry, { description: "Time unit which is used for scheduled order loading." })),
		value: n.int().gt(0).register(n.globalRegistry, { description: "Amount of time units between each scheduled order loading attempt." })
	}).register(n.globalRegistry, { description: "Schedule which is used for order loading." })
}).register(n.globalRegistry, { description: "Order extraction configuration." }).optional() }));
n.object({
	body: Te,
	path: n.never().optional(),
	query: n.never().optional()
}), n.object({
	body: Ee,
	path: n.never().optional(),
	query: n.never().optional()
});
var Ne = X;
n.object({
	body: De,
	path: n.never().optional(),
	query: n.never().optional()
});
var Pe = n.void().register(n.globalRegistry, { description: "Successful removal." });
n.object({
	body: Oe,
	path: n.never().optional(),
	query: n.never().optional()
});
var Fe = X;
n.object({
	body: ke,
	path: n.never().optional(),
	query: n.never().optional()
});
var Ie = n.union([n.object({ status: n.literal("DELEGATION_REQUESTED") }).and(Y), n.object({ status: n.literal("DELEGATION_REQUIRED") }).and(q)]);
n.object({
	body: n.never().optional(),
	path: n.never().optional(),
	query: n.object({ filter: n.object({ shopId: n.array(n.string()).optional() }).optional() }).optional()
});
var Le = n.object({ results: n.array(X) }).register(n.globalRegistry, { description: "Found sales channels." });
n.object({
	body: n.never().optional(),
	path: n.object({ salesChannelId: n.uuid().register(n.globalRegistry, { description: "The ID of the sales channel." }) }),
	query: n.never().optional()
});
var Re = X, Q = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await I.parseAsync(e),
	responseValidator: async (e) => await Ae.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/create-sales-channel",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ze = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await L.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/extract-orders",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Be = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await R.parseAsync(e),
	responseValidator: async (e) => await je.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/disable-order-loading",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ve = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await z.parseAsync(e),
	responseValidator: async (e) => await Me.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/enable-order-loading",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), He = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await B.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/import-products",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ue = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await V.parseAsync(e),
	responseValidator: async (e) => await Ne.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/manage-inventory-for-imported-products",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), We = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await H.parseAsync(e),
	responseValidator: async (e) => await Pe.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/remove-sales-channel",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ge = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await U.parseAsync(e),
	responseValidator: async (e) => await Fe.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/rename-sales-channel",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), $ = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await W.parseAsync(e),
	responseValidator: async (e) => await Ie.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/request-delegation",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ke = (e) => (e?.client ?? S).get({
	requestValidator: async (e) => await ve.parseAsync(e),
	responseValidator: async (e) => await Le.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/sales-channels",
	...e
}), qe = (e) => (e.client ?? S).get({
	requestValidator: async (e) => await G.parseAsync(e),
	responseValidator: async (e) => await Re.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/sales-channels/{salesChannelId}",
	...e
}), Je = (e) => {
	let t = new URLSearchParams(), n = e.filter;
	return n && Object.entries(n).forEach(([e, n]) => {
		Array.isArray(n) ? n.forEach((n) => t.append(`filter[${e}]`, n)) : n !== void 0 && t.append(`filter[${e}]`, n);
	}), t.toString();
}, Ye = () => S.getConfig().auth, Xe = (n = { token: void 0 }) => {
	if (!n.token) throw Error("Token is required");
	let r = {
		baseUrl: e,
		auth: n.token
	};
	return n.environment && n.environment === "acceptance" && (r.baseUrl = t), n.locale && (r.headers = {
		...r.headers,
		"Accept-Language": n.locale
	}), S.setConfig(r), n.token;
}, Ze = (e) => {
	S.setConfig({ headers: {
		...S.getConfig().headers,
		"Accept-Language": e
	} });
}, Qe = async (e) => (await qe({ path: { salesChannelId: e } })).data, $e = async (e = []) => {
	let t = {};
	return e.length > 0 && (t.query = { filter: { shopId: e } }, t.querySerializer = Je), (await Ke(t)).data;
}, et = async (e) => {
	let { name: t, shopId: n, url: r } = e;
	return (await Q({ body: {
		name: t,
		shopId: n,
		url: r
	} })).data;
}, tt = async (e) => {
	await We({ body: { salesChannelId: e } });
}, nt = async (e) => {
	let { name: t, salesChannelId: n } = e;
	return (await Ge({ body: {
		name: t,
		salesChannelId: n
	} })).data;
}, rt = async (e) => (await Ve({ body: { salesChannelId: e } })).data, it = async (e) => (await Be({ body: { salesChannelId: e } })).data, at = async (e = []) => (await He({ body: { salesChannelIds: e } }), !0), ot = async (e) => (await $({ body: { salesChannelId: e } })).data;
function st() {
	return {
		createSalesChannel: et,
		disableOrderLoading: it,
		enableOrderLoading: rt,
		getSalesChannelById: Qe,
		getSalesChannels: $e,
		getToken: Ye,
		importProducts: at,
		initClient: Xe,
		removeSalesChannel: tt,
		renameSalesChannel: nt,
		requestDelegation: ot,
		setAcceptLanguageHeader: Ze
	};
}
//#endregion
export { L as A, F as B, j as C, fe as D, R as E, he as F, P as G, ue as H, U as I, E as J, D as K, ge as L, V as M, me as N, z as O, H as P, W as R, A as S, de as T, M as U, le as V, N as W, S as X, w as Y, C as _, Be as a, ve as b, He as c, Ge as d, $ as f, se as g, k as h, Q as i, B as j, pe as k, Ue as l, ce as m, Ke as n, Ve as o, O as p, T as q, qe as r, ze as s, st as t, We as u, G as v, I as w, ye as x, be as y, _e as z };
